<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  created () {
    document.title = this.$utils.getSiteTitle()
  }
}
</script>

<style lang="sass">
@import "../../styles/index.scss"
</style>



// WEBPACK FOOTER //
// src/pages/index/App.vue